import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { logisticsApi, type Shipment, type TrackingResponse } from '../../api/logistics';

export function TrackingPage() {
  const [shipments, setShipments] = useState<Shipment[]>([]);
  const [tracking, setTracking] = useState<TrackingResponse | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void logisticsApi.listShipments().then(setShipments).catch((e) => setError(String(e)));
  }, []);

  async function loadTracking(id: string) {
    try {
      setTracking(await logisticsApi.tracking(id));
    } catch (e) {
      setError(String(e));
    }
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/logistics" className="text-sm text-slate-600 hover:underline">← Logistics hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Tracking dashboard</h1>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
      <ul className="mt-4 space-y-2">
        {shipments.map((s) => (
          <li key={s.id}>
            <button type="button" onClick={() => void loadTracking(s.id)}
              className="rounded border px-3 py-2 text-sm hover:bg-slate-50">
              Track {s.shipment_number} ({s.status})
            </button>
          </li>
        ))}
      </ul>
      {tracking && (
        <div className="mt-6 rounded-xl border p-4">
          <p className="font-semibold">{tracking.tracking_number || 'No AWB yet'}</p>
          <p className="text-sm text-slate-600">Status: {tracking.status}</p>
          <ul className="mt-3 space-y-1 text-sm">
            {tracking.events?.map((e, i) => (
              <li key={i}>{e.occurred_at}: {e.description}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
